<template>
  <div class="row">
    <div class="col-md-3 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="d-sm-flex flex-row flex-wrap text-center text-sm-left align-items-center">
            <img :src="$auth.user.picture" class="img-lg rounded" alt="profile image" referrerpolicy="no-referrer"/>
            <div class="ml-sm-3 ml-md-0 ml-xl-3 mt-2 mt-sm-0 mt-md-2 mt-xl-0">
              <h6 class="mb-0">{{ $auth.user.name }}</h6>
              <p class="text-muted mb-1">{{ $auth.user.email }}</p>
              <p class="mb-0 text-success font-weight-bold">{{ $auth.user.nickname }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-9 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h6 class="mb-0">Token</h6>
          <pre>{{ token }}</pre>
        </div>
      </div>
    </div>
    <div class="col-md-6 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h6 class="mb-0">User</h6>
          <pre>{{ JSON.stringify($auth.user, null, 2) }}</pre>
        </div>
      </div>
    </div>
    <div class="col-md-6 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h6 class="mb-0">Organisations</h6>
          <pre>{{ organisations }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      token: '',
      organisations: {}
    }
  },
  methods: {
    // Log the user in
    async getToken () {
      this.token = await this.$auth.getTokenSilently()
      this.organisations = await this.$apiClient.organisationGetAll()
    }
  },
  mounted () {
    this.getToken()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/profile.vue